module.exports = __webpack_public_path__ + "static/logo-kreativna-kuca-0e0291bb3775de4b008b205ca77695a2.png";